import { navLinkBase } from "../../utils/styles";
import { MenuItem, MenuItemRenderer } from "./MenuItemRenderer";
import { DropdownMenu } from "./DropdownMenu";

interface DesktopNavigationProps {
  menuItems: MenuItem[];
}

export function DesktopNavigation({ menuItems }: DesktopNavigationProps) {
  return (
    <div className="hidden lg:flex lg:gap-6 xl:gap-12 lg:justify-end">
      {menuItems.map(item => {
        if (item.type === "group") {
          return (
            <DropdownMenu
              key={item.name}
              item={item}
              className={navLinkBase}
            />
          );
        }

        return (
          <MenuItemRenderer
            key={item.name}
            item={item}
            className={navLinkBase}
          />
        );
      })}
    </div>
  );
}